// Date formatting and parsing utilities
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import { DELIVERY_DAYS, LOCK_HOURS } from '../constants/meals';
// Extend dayjs with timezone support
dayjs.extend(utc);
dayjs.extend(timezone);

export const dayOfWeek = {
    0: 'sunday',
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday'
};

export const formatDeliveryDate = (dateString) => {
    if (dateString === 'No Date') return 'No Date';

    try {
        // Parse the date and format it in Eastern Time
        return dayjs.tz(dateString, 'America/New_York').format('ddd MMM D');
    } catch {
        return dateString;
    }
};

export const parseEstDate = (dateString) => {
    // Parse date string and return as dayjs object in Eastern Time
    return dayjs.tz(dateString, 'America/New_York');
};

export const sortDeliveryDates = (dates) => {
    return Array.from(dates).sort((a, b) => {
        if (a === 'No Date') return 1;
        if (b === 'No Date') return -1;
        return parseEstDate(a).valueOf() - parseEstDate(b).valueOf();
    });
};

export const getCutoffTime = (deliveryDate) => {
    // Parse delivery date in Eastern Time
    const deliveryDateObj = dayjs.tz(deliveryDate, 'America/New_York');

    // Get the day of week (0 = Sunday, 1 = Monday, etc.)
    const deliveryDay = deliveryDateObj.day();

    if (deliveryDay === DELIVERY_DAYS.MONDAY) { // Monday delivery
        // Lock on Saturday at 2 PM EST
        const lockDate = deliveryDateObj
            .subtract(2, 'day') // Go back 2 days (Monday -> Saturday)
            .hour(LOCK_HOURS.MONDAY_DELIVERY)
            .minute(0)
            .second(0)
            .millisecond(0);

        return lockDate.toDate();

    } else if (deliveryDay === DELIVERY_DAYS.THURSDAY) { // Thursday delivery
        // Lock on Tuesday at 12 PM EST (noon)
        const lockDate = deliveryDateObj
            .subtract(2, 'day') // Go back 2 days (Thursday -> Tuesday)
            .hour(LOCK_HOURS.THURSDAY_DELIVERY)
            .minute(0)
            .second(0)
            .millisecond(0);

        return lockDate.toDate();

    } else if (deliveryDay === DELIVERY_DAYS.SUNDAY) { // Sunday delivery
        // Lock on Friday at 10 PM EST
        const lockDate = deliveryDateObj
            .subtract(2, 'day') // Go back 2 days (Sunday -> Friday)
            .hour(LOCK_HOURS.SUNDAY_DELIVERY)
            .minute(0)
            .second(0)
            .millisecond(0);

        return lockDate.toDate()
    } else {
        const lockDate = deliveryDateObj
            .subtract(2, 'day') // Go back 2 days (Other -> Thursday)
            .hour(LOCK_HOURS.OTHER_DELIVERY)
            .minute(0)
            .second(0)
            .millisecond(0);
        return lockDate.toDate();
    }
};

// Helper function to format lock date (Date object)
export const formatLockDate = (lockDate) => {
    if (!lockDate) return '';

    return dayjs.tz(lockDate, 'America/New_York').format('MMM D, h:mm A');
};

export const getDayOfWeek = (date) => {
    return dayjs.tz(date, 'America/New_York').format('dddd');
};